export default "__VITE_ASSET__CLPBA_5U__"